// Wishlist System + Page Popup Modal
// key: 'tg_wishlist_items'

(function () {
  const STORAGE_KEY = 'tg_wishlist_items';

  function getWishlist() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      console.warn('[Wishlist] parse error', e);
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      console.warn('[Wishlist] save error', e);
    }
  }

  function findIndex(items, id) {
    return items.findIndex((item) => String(item.id) === String(id));
  }

  function updateCounters() {
    const items = getWishlist();
    const count = items.length;

    // Header / icon count, if you added [data-wishlist-count]
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = count;
    });

    // Floating button count, if present
    const floatCount = document.querySelector('[data-wishlist-floating-count]');
    if (floatCount) floatCount.textContent = count;
  }

  function updateButtonsState() {
    const items = getWishlist();
    const ids = items.map((i) => String(i.id));

    document.querySelectorAll('.wishlist-button').forEach((btn) => {
      const id = btn.dataset.productId;
      if (!id) return;

      const active = ids.includes(String(id));
      btn.classList.toggle('wishlist-button--active', active);

      const icon = btn.querySelector('.wishlist-button__icon');
      if (icon) icon.textContent = active ? '♥' : '♡';
    });

    updateCounters();
  }

  // =============== MODAL (PAGE POPUP) ===============

  let modal, itemsContainer, emptyTextEl;

  function ensureModal() {
    if (modal) return;

    modal = document.getElementById('tg-wishlist-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'tg-wishlist-modal';
      modal.className = 'tg-wishlist-modal';
      modal.setAttribute('aria-hidden', 'true');

      modal.innerHTML = `
        <div class="tg-wishlist-modal__backdrop" data-wishlist-modal-close></div>
        <div class="tg-wishlist-modal__dialog" role="dialog" aria-modal="true" aria-label="Wishlist">
          <header class="tg-wishlist-modal__header">
            <h2 class="tg-wishlist-modal__title">My Wishlist</h2>
            <button type="button" class="tg-wishlist-modal__close" data-wishlist-modal-close>&times;</button>
          </header>
          <p class="tg-wishlist-modal__empty" id="tg-wishlist-modal-empty">Your wishlist is empty.</p>
          <div class="tg-wishlist-modal__items" id="tg-wishlist-modal-items"></div>
        </div>
      `;

      document.body.appendChild(modal);
    }

    itemsContainer = document.getElementById('tg-wishlist-modal-items');
    emptyTextEl = document.getElementById('tg-wishlist-modal-empty');

    // Close handlers
    modal.addEventListener('click', function (e) {
      if (e.target.matches('[data-wishlist-modal-close]')) {
        closeWishlistModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeWishlistModal();
      }
    });
  }

  function renderWishlistModal() {
    ensureModal();
    const items = getWishlist();

    if (!itemsContainer) return;

    itemsContainer.innerHTML = '';

    if (!items.length) {
      if (emptyTextEl) emptyTextEl.style.display = 'block';
      return;
    }

    if (emptyTextEl) emptyTextEl.style.display = 'none';

    items.forEach((item) => {
      const card = document.createElement('article');
      card.className = 'tg-wishlist-modal__card';

      card.innerHTML = `
        <a href="${item.url || '#'}" class="tg-wishlist-modal__image-wrap">
          ${
            item.image
              ? `<img src="${item.image}" alt="${item.title || 'Product'}">`
              : `<div class="tg-wishlist-modal__image-placeholder">No image</div>`
          }
        </a>
        <div class="tg-wishlist-modal__body">
          <a href="${item.url || '#'}" class="tg-wishlist-modal__product-title">
            ${item.title || 'Product'}
          </a>
          <div class="tg-wishlist-modal__actions">
            <a href="${item.url || '#'}" class="tg-wishlist-modal__view">View product</a>
            <button
              type="button"
              class="tg-wishlist-modal__remove"
              data-remove-id="${item.id}"
            >
              Remove
            </button>
          </div>
        </div>
      `;

      itemsContainer.appendChild(card);
    });

    // Remove handler (delegated)
    itemsContainer.addEventListener(
      'click',
      function (e) {
        const btn = e.target.closest('[data-remove-id]');
        if (!btn) return;

        const id = btn.getAttribute('data-remove-id');
        let items = getWishlist();
        const idx = findIndex(items, id);

        if (idx !== -1) {
          items.splice(idx, 1);
          saveWishlist(items);
          renderWishlistModal();
          updateButtonsState();
        }
      },
      { once: true }
    );
  }

  function openWishlistModal() {
    ensureModal();
    renderWishlistModal();
    if (!modal) return;

    modal.classList.add('tg-wishlist-modal--open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tg-wishlist-modal-open');
  }

  function closeWishlistModal() {
    if (!modal) return;
    modal.classList.remove('tg-wishlist-modal--open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tg-wishlist-modal-open');
  }

  // =============== EVENTS ===============

  function handleWishlistButtonClick(e) {
    const btn = e.target.closest('.wishlist-button');
    if (!btn) return;

    const id = btn.dataset.productId;
    if (!id) return;

    let items = getWishlist();
    const idx = findIndex(items, id);
    let added = false;

    if (idx === -1) {
      // add
      items.push({
        id: id,
        title: btn.dataset.productTitle || '',
        url: btn.dataset.productUrl || '#',
        image: btn.dataset.productImage || ''
      });
      added = true;
    } else {
      // remove
      items.splice(idx, 1);
      added = false;
    }

    saveWishlist(items);
    updateButtonsState();

    btn.classList.add('wishlist-button--pulse');
    setTimeout(() => btn.classList.remove('wishlist-button--pulse'), 250);

    // 👇 yaha pe page-style popup kholega
    openWishlistModal();
  }

  function handleOpenModalClick(e) {
    const trigger = e.target.closest('[data-open-wishlist-modal], .header-actions__wishlist');
    if (!trigger) return;

    // anchor par default navigation rok do
    if (trigger.tagName === 'A') {
      e.preventDefault();
    }
    openWishlistModal();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.body.addEventListener('click', handleWishlistButtonClick);
    document.body.addEventListener('click', handleOpenModalClick);
    updateButtonsState();
  });
})();
